export const getCertificateActionRequest = (registrationId: number, action: string) =>
  action === "REVOKE"
    ? {
        method: "POST" as const,
        url: `/admin/event-registrations/${registrationId}/certificate/revoke`,
      }
    : {
        method: "PATCH" as const,
        url: `/admin/event-registrations/${registrationId}/certificate`,
      };
